import { useQuery } from "react-query";
import { clearStoredAuth } from "../utils";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config";

const fetchFlightNoteHistory = async (flightId: string): Promise<OpsNoteHistory> => {
  const res = await fetch(`${API_URL}/ops/notes/${flightId}/history`, {
    credentials: "include",
  });

  if (!res.ok) {
    throw new Error(`${res.status}`);
  }

  return res.json();
};

export const useFlightNoteHistory = (flightId: string | null, enabled: boolean = true) => {
  const navigate = useNavigate();

  return useQuery<OpsNoteHistory, Error>(
    ["flight-note-history", flightId],
    () => fetchFlightNoteHistory(flightId!),
    {
      enabled: !!flightId && enabled,
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30 * 1000, // Cache for 30 seconds
      onError: (error: Error) => {
        if (error.message === "401") {
          clearStoredAuth();
          navigate("/");
        }
      },
    }
  );
};

